import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';


export default {
  name: 'CmrContrPnlEditReading',
  components: {
    BottomNavButtons: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelBottomNavButtons.vue').default,
    Readings: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelEditReading/readings/readings.vue').default,
    MessagesAndDetails: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelEditReading/messagesAndDetails/messagesAndDetails.vue').default,
    Photos: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelEditReading/photos/photos.vue').default,
    History: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelEditReading/history/history.vue').default,
    ReadingsMap: require('@/employee/captureMeterReadings/cmrControlPanel/readingsMap/readingsMap.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      showMap: false,
      currentTab: 'readings',
      loader: false,
      editingReading: {},
      infoLine1: '',
      infoLine2: '',
      infoLine3: '',
      readingsDataObj: {},
      showTabs: false,
      photoList: [],
      modifyConsumption: false,
      readOnly: false,
      rejectReading: false,
      scrollOptions: { behavior: 'smooth', block: 'center', inline: 'end' },
      readings: [],
      curReadingDisplay: {},
      prevReadingDisplay: {},
    }
  },
  computed: {
    accountOrPropRef: function () {
      return this.isPropertyOriented == true
        ? this.editingReading.propRef
        : this.editingReading.account;
    },
    isPropertyOriented: function () {
      return this.editReadingDataObj && this.editReadingDataObj.isPropertyOriented == true;
    },
    photosImage: function () {
      return this.photoList.length > 0 ? 'photo_camera' : 'no_photography'
    },
    actionRequestDisabled: function () {
      if (this.dataObj == null || this.dataObj.editingReading == null || this.dataObj.editingReading.actionRequestPosted)
        return true;
      else if (this.dataObj.editingReading.actionRequestPosted)
        return false;
      
      return true;
    },

    lastPageButtonDisabled: function () {
      if (this.readings.length < 3)
        return true
      else
        return this.editingReading.sequence == this.readings[this.readings.length - 1].sequence;
    },
    firstPageButtonDisabled: function () {
      if (this.readings.length < 3)
        return true
      else
        return this.editingReading.sequence == this.readings[0].sequence;
    },

    filteredReadings: function () {
      return this.readings;
    }
  },
  watch: {
    currentTab: function (val) {
      if (val === 'photos')
        this.$root.$emit('edit_reading_photo_window_init');

      if (val === 'history')
        this.$root.$emit('history_window_init');

      this.scrollTo('actions-element', { behavior: 'smooth', block: 'start', inline: 'center' });
    },
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadingsAdmin != true)
      this.$router.push('/employeeHome');

    this.$root.$on('editing_reading_selected', this.init);
    this.$root.$on('get_cmr_photos_list', this.getPhotosList);
    this.$root.$on('selected_reading_changed', (numb) => this.navigate('go_to_reading', numb));
  },
  methods: {
    showMapFunc() {
      this.showMap = !this.showMap;

      if (this.showMap)
        this.$scrollToElement('readingsMapButton');
    },
    highlightField(elem, type, addClass = false) {
      if (!elem)
        return;

      let cssClass = 'highlight-field-blue';

      if (type == 1)
        cssClass = 'highlight-field-orange';
      if (type == 2)
        cssClass = 'highlight-field-red';

      if (addClass) {
        document.getElementById(elem).classList.add(cssClass);
        window.scroll({
          top: document.body.scrollHeight,
          left: 0,
          behavior: "smooth",
        });
      }        
      else
        document.getElementById(elem).classList.remove(cssClass);


    },
    scrollTo(elem, param = null) {
      if (!param)
        param = this.scrollOptions;

      this.$scrollToElement(elem, param);
    },
    init() {
      this.editingReading = this.dataObj.editingReading;
      this.getConnectionSpHeader();
      this.getPhotosList();
      this.showTabs = true;
      this.rejectReading = this.editingReading.rejected;
      this.readings = this.dataObj.readings;
      this.prevReadingDisplay = {
        date: this.editingReading.prDate1,
        read: this.editingReading.prRead1,
        cons: this.editingReading.prCons1,
        avrgCons: this.editingReading.prAvrCns,
        messages: ' '
      };

      this.curReadingDisplay = {
        date: this.editingReading.crDate,
        read: this.editingReading.crReading,
        cons: this.editingReading.consumption,
        avrgCons: this.editingReading.curAvrCns,
        messages: ' '
      };

      this.$root.$emit('cmr_edit_reading_changed');
    },
    navigate(to, numb) {
      let temp;
      switch (to) {
        case 'next':
          //find the reading with the next bigger sequence
          this.dataObj.editingReading = this.readings.filter(r => r.sequence > this.editingReading.sequence)[0];
          this.init();
          break;
        case 'end':
          this.dataObj.editingReading = this.readings[this.readings.length - 1];
          this.init();
          break;
        case 'prev':
          //find the reading with the next smaller sequence
          for (let i = this.readings.length - 1; i >= 0; i--) {
            if (this.readings[i].sequence < this.editingReading.sequence) {
              this.dataObj.editingReading = this.readings[i];
              break;
            }              
          }
          this.init();
          break;
        case 'start':
          this.dataObj.editingReading = this.readings[0];
          this.init();
          break
        case "go_to_reading":
          if (numb < 0)
            return;

          let temp = this.readings.filter(r => r.numbering == numb);
          this.dataObj.editingReading = temp[0];
          break
        default:
          break;
      }

      this.editingReading = this.dataObj.editingReading;
      this.$emit('editingReadingChange', this.dataObj.editingReading);
      this.$root.$emit("update_selected_marker");
      this.modifyConsumptionFunc(false);
      this.$root.$emit('redraw_map');
    },
    getConnectionSpHeader() {      
      axios.get("/CaptureMeterReading/GetConnectionSpHeader?connectionId=" + this.editingReading.connectionId)
        .then((response) => {
          this.infoLine1 = response.data;
        })
        .catch((e) => {
          this.infoLine1 = "";
        });
    },
    rejectReadingFunc(val) {
     // this.rejectReading = !this.rejectReading;
      this.readOnly = !this.readOnly;

      if (val)
        this.modifyConsumption = false;
    },
    changeTab(item) {
        this.currentTab = item;
    },
    getPhotosList() {
      if (this.editingReading.meterId <= 0) return;

      var parameter = {
        MeterId: this.editingReading.meterId,
        CycleId: this.dataObj.booksWalks.cycleId,
        ConnectionId: this.editingReading.connectionId,
      };

      let loader = this.$loading.show({ color: "#23348d", loader: "dots", width: 256, height: 256, backgroundColor: "#ffffff", opacity: 0.5, });
      axios.post("/CaptureMeterReading/GetPhotos", parameter)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.photoList = response.data.items;
          }
        })
        .catch((e) => {
          console.log("err", e)
        })
        .finally(loader.hide());
    },
    modifyConsumptionFunc(value) {
      this.modifyConsumption = value;
      if (value) {
        this.changeTab('readings');
        this.highlightField('currentConsumption',null, true);
      }
      else
        this.highlightField('currentConsumption');
    },

    async saveReading(closeTab = false) {
      let saveStatus = await this.updateReadingDetails();

      if (closeTab == true && saveStatus)
        this.dataObj.navigateFunc(-1);
    },
    async updateReadingDetails() {
      let reading = this.editingReading;

      if (reading == null) {

        return false;
      }

      if ((!reading.crReading || reading.crReading === null || reading.crReading === "" || reading.crReading < 0 ||
        reading.crReading > Math.pow(10, reading.noDials) - 1) && reading.accessCodeId == 0) {
        this.highlightField('currentReading', 2, true);
        return false;
        }
        
     
      //bulk meter warning about non read submeters
      if (reading.connType == 2 && this.editingOptions.customerMeterReadingUseQuarterType == true) {
        //find sub meters
        let reads = this.readings.filter((f) => f.bulkConnectionId == this.editingReading.connectionId);
        let flag = this.submetersHaveValue(reads);

        if (flag == false) {
          this.$alertMsg(this.$t("captureMR.SubconnectionsNotRead"), 3);
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }
        else {
          //check for consumptions
          let cons = 0;
          reads.forEach(r => {
            cons = cons + r.consumption;
          });

          let dif = Math.abs(cons - this.editingReading.consumption);

          if (dif >= 0) {
            this.$alertMsg(`${this.$t("captureMR.SubconnectionsConsDifference")} ${this.$t("captureMR.By")} ${dif}`, 3);
            await new Promise((resolve) => setTimeout(resolve, 2000));
          }
        }
       
      }

      if (moment(reading.crDate).isAfter(new Date())) {
        this.$alertMsg(this.$t("captureMR.currDateError"), 4);
        return false;
      }

      var parameter = {
        BookId: reading.bookId,
        WalkId: reading.walkId,
        Sequence: reading.sequence,

        CrReading: reading.crReading,
        ClockOver: reading.clockOver,
        CrDateTime: moment(reading.crDate).format("YYYY-MM-DDTHH:mm:ss"),

        AccessCodeId: reading.accessCodeId,
        MrMsgCodeId: reading.mrMsgCodeId,
        SerialNo: reading.serialNo,
        MeterMakeId: reading.meterMakeId,
        MeterSizeId: reading.meterSizeId,
        NoDials: reading.noDials,
        CellTelNo: reading.cellTelNo,
        ConsumerTypeId: reading.consumerTypeId,
        Comment: reading.comment,
        RejectReading: null,
        MeterLocationId: reading.meterLocationId
      };

      if (this.dataObj.editingOptions.allowChangeConversionFactor == true)
        parameter['ConvFactor'] = reading.convFactor;

      if (this.editingReading.originalRejectedState == false && this.rejectReading == true)
        parameter.RejectReading = true;

      if (this.editingReading.originalRejectedState == true && this.rejectReading == false)
        parameter.RejectReading = false;

      if (this.editingReading.originalRejectedState == this.rejectReading)
        parameter.RejectReading = this.rejectReading;

      return axios.post("/CaptureMeterReading/UpdateReadingDetails", parameter)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.data != null && response.data.data.status != 0) {
              this.$alertMsg(response.data.data.text, 4);
              return true;
            }

            this.$oldAlertMsg(this.$t("messages.ReadingUpdatedSuccess"), 2);
            return true;

          }
          else {
            this.$alertMsg(response.data.text, 4);
            return false;
          }
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
          return false;
        });

    },
    requestPostAction() {
      if (this.dataObj.actionRequestPosted == true)
        return;

      let param = {
        BookId: this.dataObj.editingReading.bookId,
        WalkId: this.dataObj.editingReading.walkId,
        Sequence: this.dataObj.editingReading.sequence,
      }

      axios.post("/CaptureMeterReading/IssueDescrepancyApplication", param) 
        .then((response) => {
          if (response.status == 200 && response.data == true)
              this.$alertMsg(this.$t('messages.AppIssuedSuccessfullyReviewedStaff'));
          else
            this.$alertMsg(this.$t('messages.CannotIssueApp'));
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
          this.$alertMsg(this.$t('messages.CannotIssueApp'));
        });
    },

    checkReading(val) {
      axios.post('/CaptureMeterReading/UpdateCheckReadingFlag', {
        BookId: this.dataObj.editingReading.bookId,
        WalkId: this.dataObj.editingReading.walkId,
        Sequence: this.dataObj.editingReading.sequence,
        CheckReading: val,
      })
        .then(res => {
          if (res.status != 200 || res.data.data.status != 0) {
            this.dataObj.editingReading.checkReading = false;
          }
        })
        .catch(err => { this.dataObj.editingReading.checkReading = false; })
    }
  }
}
